/**
 * Search semantics for the Combobox primitive: every whitespace-separated
 * query token must be a substring of the option's label or one of its
 * keywords, case-insensitively. Plain substring matching on purpose — no
 * fuzzy scoring; predictable results matter more in a form picker.
 */

export type ComboboxFilterOption = {
    value: string
    label: string
    keywords?: string[]
}

export function filterComboboxOptions<T extends ComboboxFilterOption>(
    options: T[],
    query: string
): T[] {
    const tokens = query.trim().toLowerCase().split(/\s+/).filter(Boolean)
    if (tokens.length === 0) return options

    return options.filter((option) => {
        const haystack = [option.label, ...(option.keywords ?? [])].join(' ').toLowerCase()
        return tokens.every((token) => haystack.includes(token))
    })
}
